import React from "react";
import { Link } from "react-router-dom";
import "./Hero.css";

function Hero() {
  return (
    <section className="hero">
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src="https://res.cloudinary.com/dozvtnkeb/video/upload/videoprincipal.mp4" type="video/mp4" />
        Tu navegador no soporta el elemento de video.
      </video>
      <div className="hero-content">
        <h2>Cuida tu Cuerpo con Suplymar</h2>
        <p>
          Productos ortopédicos de calidad premium diseñados para aliviar el
          dolor y acompañarte en cada movimiento.
        </p>
        <Link to="/productos" className="cta-btn">
          Explorar Productos
        </Link>
      </div>
    </section>
  );
}

export default Hero;
